import { createParser, EventSourceParser, ParseEvent } from 'eventsource-parser';

export const createEventStreamParser = createParser;
export type EventStreamParser = EventSourceParser;
export type { ParseEvent };
